import { createRouter, createWebHashHistory } from "vue-router";

export default createRouter({
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  routes: [
    {
      name: "HomePage",
      path: "/",
      component: () => import("@/views/Home"),
    },
    {
      name: "AccessUrls",
      path: "/access",
      component: () => import("@/views/AccessUrls"),
    },
    {
      name: "MerchantInformations",
      path: "/mrcInformations",
      component: () => import("@/views/MerchantInformations"),
    },
    {
      name: "TestCards",
      path: "/testCards",
      component: () => import("@/views/TestCards"),
    },
    //#region TokenAndInstallment Begin
    {
      path: "/tokenandinstallment",
      children: [
        {
          name: "Tokenize",
          path: "tokenize",
          component: () => import("@/views/TokenAndInstallment/Tokenize"),
        },
        {
          name: "MerchantCommissionAPI",
          path: "merchantcommissionapi",
          component: () => import("@/views/TokenAndInstallment/MerchantCommissionAPI"),
        },
        {
          name: "InstallmentInformations",
          path: "installmentInformations",
          component: () => import("@/views/TokenAndInstallment/InstallmentInformations"),
        },
        {
          name: "MerchantActiveInstallments",
          path: "merchantactiveinstallments",
          component: () => import("@/views/TokenAndInstallment/MerchantActiveInstallments"),
        },
      ],
    },
    //#endregion TokenAndInstallment End

    //#region PaymentControlRefund Begin
    {
      path: "/paymentcontrolrefund",
      children: [
        {
          name: "HashVerify",
          path: "hashverify",
          component: () => import("@/views/PaymentControlRefund/HashVerify"),
        },
        {
          name: "SecurePayment",
          path: "securepayment",
          component: () => import("@/views/PaymentControlRefund/SecurePayment"),
        },
        {
          name: "CompletePaymentAPI",
          path: "completepaymentapi",
          component: () => import("@/views/PaymentControlRefund/CompletePaymentAPI"),
        },
        {
          name: "NonSecurePayment",
          path: "nonsecurepayment",
          component: () => import("@/views/PaymentControlRefund/NonSecurePayment"),
        },
        {
          name: "PayWithQNBPay",
          path: "paywithqnbpay",
          component: () => import("@/views/PaymentControlRefund/PayWithQNBPay"),
        },
        {
          name: "PayByToken",
          path: "paybytoken",
          component: () => import("@/views/PaymentControlRefund/PayByToken"),
        },
        {
          name: "PayByToken3D",
          path: "paybytoken3d",
          component: () => import("@/views/PaymentControlRefund/PayByToken3D"),
        },
        {
          name: "TransactionStatus",
          path: "transactionstatus",
          component: () => import("@/views/PaymentControlRefund/TransactionStatus"),
        },
        {
          name: "PaymentVerify",
          path: "paymentverify",
          component: () => import("@/views/PaymentControlRefund/PaymentVerify"),
        },
        {
          name: "PaymentRefund",
          path: "paymentrefund",
          component: () => import("@/views/PaymentControlRefund/PaymentRefund"),
        },
        // {
        //   name: "GetTransaction",
        //   path: "gettransaction",
        //   component: () => import("@/views/PaymentControlRefund/GetTransaction"),
        // },
        // {
        //   name: "AllTransactions",
        //   path: "alltransactions",
        //   component: () => import("@/views/PaymentControlRefund/AllTransactions"),
        // },
      ],
    },
    //#endregion PaymentControlRefund End

    //#region StatusCodes Begin
    {
      path: "/statuscodes",
      children: [
        {
          name: "ServerStatusCodes",
          path: "serverstatuscodes",
          component: () => import("@/views/StatusCodes/ServerStatusCodes"),
        },
        {
          name: "ApplicationStatusCodes",
          path: "applicationstatuscodes",
          component: () => import("@/views/StatusCodes/ApplicationStatusCodes"),
        },
      ],
    },
    //#endregion StatusCodes End

    //#region WebHooks Begin
    {
      path: "/webhooks",
      children: [
        {
          name: "PaymentWebHook",
          path: "paymentwebhook",
          component: () => import("@/views/WebHooks/PaymentWebHook"),
        },
        {
          name: "RefundWebHook",
          path: "refundwebhook",
          component: () => import("@/views/WebHooks/RefundWebHook"),
        },
      ],
    },
    //#endregion WebHooks End

    //#region Attachments Begin
    {
      path: "/attachments",
      children: [
        {
          name: "PostmanCollections",
          path: "postmancollections",
          component: () => import("@/views/Attachments/PostmanCollections"),
        },
        {
          name: "WooCommerce",
          path: "woocommerce",
          component: () => import("@/views/Attachments/WooCommerce"),
        },
        {
          name: "OpenCart",
          path: "opencart",
          component: () => import("@/views/Attachments/OpenCart"),
        },
      ],
    },
    //#endregion Attachments End
    {
      name: "SampleProject",
      path: "/sampleproject",
      component: () => import("@/views/SampleProject"),
    },
    //#region Simple Component- will be used if needed.
    // {
    //   name: "Simple",
    //   path: "/simple",
    //   meta: {
    //     layout: "simple",
    //   },
    //   component: () => import("@/components/HelloWorld"),
    // },
    //#endregion Simple Component- will be used if needed.
  ],
  history: createWebHashHistory(),
});
